import {
    Box,
    Button,
    Card,
    FormControl, FormControlLabel,
    MenuItem, Modal,
    Popover,
    Select, Switch,
    Tab,
    Tabs,
    TextField,
    Typography
} from "@material-ui/core";
import clsx from "clsx";
import {USER_TYPE} from "../../../stores/UserStore";
import {SketchPicker} from "react-color";
import NoImage from "../../../common/images/NoImage.jpg";
import React, {useState} from "react";
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import {NoticeLangName} from "../../../common/enums/ContentEnum";
import {ReactComponent as ArrowDownIcon} from '../../../common/images/ArrowDownIcon.svg';
import {ReactComponent as TranslationRefreshIcon} from '../../../common/images/TranslationRefreshIcon.svg';
import PropTypes from "prop-types";
import {useStyles} from "./styles/NoticeStyle";
import {useHistory} from "react-router-dom";
import {NotificationType, TabType} from "../../../stores/NoticeStore";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function NoticeBanner(props) {

    const classes = useStyles();
    const {authStore, noticeStore, localeStore, groupStore} = props;
    const {intl} = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const history = useHistory();

    const [tabnum, setTabnum] = React.useState(0);
    const userType = props.authStore.getUserType();

    const LocaleList = [
        {value: NotificationType.Select, label: intl.formatMessage({id: "select"})},
        {value: 'US', label: intl.formatMessage({id: "US"})},
        {value: 'KR', label: intl.formatMessage({id: "KR"})},
        {value: 'JP', label: intl.formatMessage({id: "JP"})},
        {value: 'CN', label: intl.formatMessage({id: "CN"})},
        {value: 'TH', label: intl.formatMessage({id: "TH"})},
        {value: 'VN', label: intl.formatMessage({id: "VN"})},
        {value: 'MN', label: intl.formatMessage({id: "MN"})},
        {value: 'ID', label: intl.formatMessage({id: "ID"})},
        {value: 'RU', label: intl.formatMessage({id: "RU"})},
        {value: 'TW', label: intl.formatMessage({id: "TW"})},
        {value: 'ETC', label: intl.formatMessage({id: "ETC"})},
    ]

    const handleChangeLocale = (e) => {
        noticeStore.setSelectLocale(e.target.value);
        noticeStore.setSelectOption(NotificationType.Locale)
        groupStore.getLocalGroups(e.target.value);
        noticeStore.setSelectGroupId(NotificationType.All);
    }

    const handleChangeGroup = (e) => {
        if (noticeStore.selectLocale === NotificationType.Select) {
            alert(`${intl.formatMessage({id: "SelectAlert"})}`);
        } else {
            noticeStore.setSelectGroupId(e.target.value);
            if (e.target.value !== NotificationType.All) {
                noticeStore.setSelectOption(NotificationType.Group);
            }
        }
    }

    const handleChangeTitle = (event) => {
        const value = event.target.value;
        if (value.length <= 30) {
            noticeStore.setTitle(value);
        }
    }

    const handleChangeSubtitle = (event) => {
        const value = event.target.value;
        if (value.length <= 30) {
            noticeStore.setSubtitle(value);
        }
    }

    const handleChangeTab = (event, newValue) => {
        setTabnum(newValue);
        if (newValue === 0) {
            noticeStore.setCurrentTab(TabType.title);
        } else if (newValue === 1) {
            noticeStore.setCurrentTab(TabType.subTitle);
        }
    };

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpen(false);
    };

    const handleChangeColor = (color) => {
        noticeStore.setBackground(color.hex);
    }

    const handleClickRemoveThumbnail = (e) => {
        noticeStore.setImageChange();
        noticeStore.initNotificationImage();
        console.log("Delete Uploaded Image");
    }

    const openFileExplorer = () => {
        noticeStore.setImageChange();
        const input = document.getElementById('ThumbnailUpload');
        input.click();
    }

    const uploadThumbnail = async (e) => {
        const file = e.target.files[0];
        if (file) {
            try {
                const fileType = file.type.split('/')[1];
                const base64String = await convertFileToBase64(file);

                let modifyImage = Object.assign({}, noticeStore.notificationImage);
                modifyImage.image = `data:image/${fileType};base64,` + base64String;
                noticeStore.setNotificationImage(modifyImage);
            } catch (error) {
                console.error('Error converting Thumbnail file to base64:', error);
            }
        }
    }

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                resolve(reader.result.split(',')[1]);
            };

            reader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const translateAll = () => {
        const lang = localeStore.locale.toUpperCase();
        let text = "";
        if (noticeStore.currentTab === TabType.title) {
            text = noticeStore.title;
        } else {
            text = noticeStore.subtitle;
        }
        noticeStore.translateAllNotice(lang, text, noticeStore.currentTab, noticeStore.setNoticeTranslations);
    }

    const handleRefreshTranslationText = (translation, index) => {
        const languageCode = translation.languageCode;
        let text = "";
        if (noticeStore.currentTab === TabType.title) {
            text = noticeStore.title;
        } else {
            text = noticeStore.subtitle;
        }
        noticeStore.translateNotice(index, languageCode, localeStore.locale.toUpperCase(), text, noticeStore.currentTab, noticeStore.setNoticeElement)
    }

    const handleChangeEnable = async (checked, index) => {
        noticeStore.setEnable(checked, index);
    }

    function TranslateButton({disabled, onClick}) {
        return (
            <Box display={"flex"} justifyContent={"flex-end"}>
                <Button
                    disabled={disabled}
                    style={{borderColor: disabled ? 'gray' : '#7445FF'}}
                    variant={'outlined'}
                    onClick={onClick}
                >
                    <Typography
                        style={{color: disabled ? 'gray' : '#7445FF'}}>{intl.formatMessage({id: "translation"})}</Typography>
                </Button>
            </Box>
        );
    }

    const handleTextChange = (event, translation) => {
        const newText = event.target.value;
        translation[noticeStore.currentTab] = newText;
    };

    const handleDeleteNotice = async () => {
        await noticeStore.deleteNotice(props.noticeId);
        setOpenAlert(false);
        history.push(`/notice`);
    }

    const handleOpenDelete = () => {
        setOpenAlert(true);
    };

    const handleCloseDelete = () => {
        setOpenAlert(false);
    };

    const translatingBox = (translation, index) => {
        const languageCode = translation.languageCode;
        return (
            <React.Fragment key={index}>
                {noticeStore.getCurrentIndexWithLangCode(localeStore.locale.toUpperCase()) !== index &&
                    <div key={index}>
                        <Box display={'flex'} justifyContent={'space-between'} className={classes.translationTitle}>
                            <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}
                                 style={{width: '10%'}} paddingTop={1}>
                                <Typography
                                    className={classes.langText}>{NoticeLangName[localeStore.locale.toUpperCase()][languageCode]}</Typography>
                                <Button disableRipple onClick={() => handleRefreshTranslationText(translation, index)}>
                                    <TranslationRefreshIcon/>
                                </Button>
                            </Box>
                            <Box>
                                <FormControlLabel
                                    control={<Switch
                                        checked={(translation.isEnable === true)}
                                        onChange={(event) => handleChangeEnable(translation.isEnable, index)}
                                        name="checkedB" className={classes.swichStyle}/>}
                                    label={intl.formatMessage({id: "AppDisplayed"})}
                                    labelPlacement="start"
                                />
                            </Box>
                        </Box>
                        <Box>
                            <TextField
                                id="outlined-multiline-static"
                                placeholder={intl.formatMessage({id: "TextPlaceholder"})}
                                variant="outlined"
                                value={translation[noticeStore.currentTab]}
                                onChange={(event) => handleTextChange(event, translation)}
                            />
                        </Box>
                    </div>
                }
            </React.Fragment>
        )
    }

    const disableTitle = !noticeStore.title;
    const disableSubtitle = !noticeStore.subtitle;

    return (
        <Box>
            {/* 공지 유형 */}
            <Box display={"flex"} justifyContent={"space-between"} marginBottom={3}>
                <Typography
                    style={{fontWeight: 'bold', fontSize: '1rem'}}>{intl.formatMessage({id: "NoticeType"})}</Typography>
                {props.noticeId !== "0" ? (
                    <Box marginRight={2}>
                        <Typography
                            style={{color: 'red', fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer'}}
                            onClick={handleOpenDelete}>{intl.formatMessage({id: "delete"})}</Typography>
                        <Modal
                            open={openAlert}
                            onClose={handleCloseDelete}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Box>
                                <Card style={{
                                    width: '380px',
                                    height: '200px',
                                    backgroundColor: "white",
                                    border: '1px solid black',
                                }}>
                                    <Box display={"flex"} flexDirection={"column"}>
                                        <Box display={"flex"} flexDirection={"column"} justifyContent={"center"}
                                             textAlign={"center"} marginTop={5} marginBottom={5}>
                                            <Typography>{intl.formatMessage({id: "msg_info_delete1"})}</Typography>
                                            <Typography>{intl.formatMessage({id: "msg_info_delete2"})}</Typography>
                                        </Box>
                                        <Box display={"flex"} flexDirection={"row"} justifyContent={"center"}>
                                            <Box display={"flex"} justifyContent={"center"}>
                                                <Button className={classes.setButton1} disableRipple
                                                        onClick={handleCloseDelete}>
                                                    <Typography>{intl.formatMessage({id: "cancel"})}</Typography>
                                                </Button>
                                            </Box>
                                            <Box display={"flex"} justifyContent={"center"}>
                                                <Button className={classes.setButton2} disableRipple
                                                        onClick={handleDeleteNotice}>
                                                    <Typography>{intl.formatMessage({id: "delete"})}</Typography>
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Card>
                            </Box>
                        </Modal>
                    </Box>
                ) : null}
            </Box>
            {/* 공지 유형 박스 */}
            <Box className={clsx(classes.boxWrap)}>
                <Box>
                    {userType === USER_TYPE.Admin ? (
                        <Box>
                            <Box display={"flex"} flexDirection={"row"} paddingBottom={2}>
                                <Box marginRight={3} display={"flex"} justifyContent={"flex-start"}
                                     alignItems={"center"}>
                                    <input type="radio" id="All" name="options" value={NotificationType.All}
                                           checked={noticeStore.selectOption === NotificationType.All}
                                           onChange={() => noticeStore.setSelectOption(NotificationType.All)}/>
                                    <label htmlFor="All" style={{
                                        fontWeight: 'bold',
                                        fontSize: '1rem'
                                    }}>{intl.formatMessage({id: "GeneralNotice"})}</label>
                                </Box>
                                <Box marginRight={1} display={"flex"} justifyContent={"flex-start"}
                                     alignItems={"center"}>
                                    <input type="radio" id="Locale" name="options" value={NotificationType.Locale}
                                           checked={noticeStore.selectOption === NotificationType.Locale || noticeStore.selectOption === NotificationType.Group}
                                           onChange={() => noticeStore.setSelectOption(NotificationType.Locale)}/>
                                    <label htmlFor="Locale" style={{
                                        fontWeight: 'bold',
                                        fontSize: '1rem'
                                    }}>{intl.formatMessage({id: "LocalNotice"})}</label>
                                </Box>
                                <Box marginRight={1} display={"flex"} justifyContent={"flex-start"}
                                     alignItems={"center"}>
                                    <FormControl className={classes.formControl}>
                                        <Select
                                            value={noticeStore.selectLocale}
                                            onChange={handleChangeLocale}
                                            IconComponent={(props) => (
                                                <Box>
                                                    <ArrowDownIcon  {...props} />
                                                </Box>
                                            )}
                                            MenuProps={{
                                                anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "right"
                                                },
                                                transformOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                },
                                                getContentAnchorEl: null,
                                                className: classes.selectPopover
                                            }}
                                        >
                                            {LocaleList.map((type, index) => (
                                                <MenuItem key={index} value={type.value}
                                                          style={{display: type.value === NotificationType.Select ? 'none' : 'block'}}>{type.label}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                    <FormControl className={classes.formControl}>
                                        <Select
                                            value={noticeStore.selectGroupId}
                                            onChange={handleChangeGroup}
                                            IconComponent={(props) => (
                                                <Box>
                                                    <ArrowDownIcon  {...props} />
                                                </Box>
                                            )}
                                            MenuProps={{
                                                anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "right"
                                                },
                                                transformOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                },
                                                getContentAnchorEl: null,
                                                className: classes.selectPopover
                                            }}
                                        >
                                            <MenuItem value={NotificationType.All}>{intl.formatMessage({id: "All"})}</MenuItem>
                                            {groupStore.localeGroup.map((type, index) => (
                                                <MenuItem key={index} value={type.id}>{type.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Box>
                            <Box>
                                <Typography style={{fontSize: '0.9rem'}}>
                                    {noticeStore.selectOption === NotificationType.All ? intl.formatMessage({id: "GeneralExplanation"}) : intl.formatMessage({id: "LocalExplanation"})}
                                </Typography>
                            </Box>
                        </Box>

                    ) : (
                        <Box>
                            <Box display={"flex"} flexDirection={"row"} paddingBottom={2}>
                                <Box marginRight={1} display={"flex"} justifyContent={"flex-start"}
                                     alignItems={"center"}>
                                    <Typography
                                        style={{
                                            fontWeight: 'bold',
                                            fontSize: '1rem'
                                        }}>{intl.formatMessage({id: "LocalNotice"})}</Typography>
                                </Box>
                                <Box marginRight={1} display={"flex"} justifyContent={"flex-start"}
                                     alignItems={"center"}>
                                    <input className={classes.form} type="text"
                                           value={authStore.loginUser.localeCode} readOnly/>
                                </Box>
                                <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                    <FormControl className={classes.formControl}>
                                        <Select
                                            value={noticeStore.selectGroupId}
                                            onChange={handleChangeGroup}
                                            IconComponent={(props) => (
                                                <Box>
                                                    <ArrowDownIcon  {...props} />
                                                </Box>
                                            )}
                                            MenuProps={{
                                                anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "right"
                                                },
                                                transformOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                },
                                                getContentAnchorEl: null,
                                                className: classes.selectPopover
                                            }}
                                        >
                                            <MenuItem value={NotificationType.All}>{intl.formatMessage({id: "All"})}</MenuItem>
                                            {groupStore.localeGroup.map((type, index) => (
                                                <MenuItem key={index} value={type.id}>{type.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Box>
                            <Typography style={{fontSize: '0.9rem'}}>
                                {intl.formatMessage({id: "LocalExplanation"})}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
            {/* 썸네일 */}
            <Box display={"flex"} justifyContent={"space-between"} marginTop={3} marginBottom={3}>
                <Typography
                    style={{fontWeight: 'bold', fontSize: '1rem'}}>{intl.formatMessage({id: "Thumbnail"})}</Typography>
            </Box>
            {/* 썸네일 박스 */}
            <Box className={clsx(classes.boxWrap)} marginBottom={3}>
                <Box display={"flex"} flexDirection={"row"}>
                    <Box display={"flex"} flexDirection={"column"} style={{flex: 1}}>
                        <Box marginBottom={2} display={"flex"} flexDirection={"row"} alignItems={"center"}>
                            <Box marginRight={1}>
                                <Typography
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '1rem'
                                    }}>{intl.formatMessage({id: "BackgroundColor"})}</Typography>
                            </Box>
                            <Card
                                style={{
                                    width: '18px',
                                    height: '18px',
                                    borderRadius: '50%',
                                    backgroundColor: `${noticeStore.background}`,
                                    cursor: 'pointer',
                                    border: '1px solid black',
                                }}
                                onClick={handleOpen}/>
                            <Popover
                                id={"backgroundPopOver"}
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                            >
                                <SketchPicker
                                    color={noticeStore.background}
                                    onChangeComplete={handleChangeColor}
                                />
                            </Popover>
                        </Box>
                        <Box marginBottom={2} display={"flex"} alignItems={"center"} flexDirection={"row"}>
                            <Box marginRight={2}>
                                <Typography
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '1rem'
                                    }}>{intl.formatMessage({id: "IconImage"})}</Typography>
                            </Box>
                            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                <Button className={classes.setButton} disableRipple onClick={openFileExplorer}>
                                    <Typography>{intl.formatMessage({id: "register"})}</Typography>
                                </Button>
                                {noticeStore.notificationImage.image ? (
                                    <Button className={classes.setButton} disableRipple
                                            onClick={handleClickRemoveThumbnail}>
                                        <Typography>{intl.formatMessage({id: "delete"})}</Typography>
                                    </Button>
                                ) : null}
                            </Box>
                            <input id={'ThumbnailUpload'} style={{display: 'none'}} accept={".jpg, .jpeg, .png"}
                                   onChange={uploadThumbnail} placeholder={intl.formatMessage({id: "full_file"})}
                                   type={'file'}/>
                        </Box>
                    </Box>
                    <Box style={{flex: 2}} display={"flex"} flexDirection={"row"} alignItems={"center"}>
                        <Box marginRight={2}>
                            <Typography
                                style={{
                                    fontWeight: 'bold',
                                    fontSize: '1rem'
                                }}
                            >{intl.formatMessage({id: "Thumbnail"})} {intl.formatMessage({id: "Preview"})}</Typography>
                        </Box>
                        <Box>
                            <Card style={{
                                backgroundColor: `${noticeStore.background}`,
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: 328,
                                borderRadius: 15,
                                height: 66
                            }}>
                                <Box style={{
                                    padding: '10px 15px',
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}>
                                    {noticeStore.notificationImage.image ? (
                                        <img style={{width: '45px', height: '45px'}}
                                             src={noticeStore.notificationImage.image}
                                             alt="썸네일 이미지"/>
                                    ) : (
                                        <img className={classes.iconBtn} style={{width: '45px', height: '45px'}}
                                             src={NoImage} alt='NoImage'/>
                                    )}
                                </Box>
                                <Box style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    textAlign: 'left',
                                    width: '100%'
                                }}>
                                    <Typography style={{
                                        fontSize: '0.9rem',
                                        color: 'textSecondary'
                                    }}>{noticeStore.title}</Typography>
                                    <Typography style={{
                                        fontWeight: 'bold',
                                        fontSize: '1rem'
                                    }}>{noticeStore.subtitle}</Typography>
                                </Box>
                            </Card>
                        </Box>
                    </Box>
                </Box>
                {/* 타이틀, 서브 타이틀 탭 */}
                <Box>
                    <Box position="static" className={classes.tabBox}>
                        <Tabs value={tabnum} onChange={handleChangeTab} aria-label="simple tabs example">
                            <Tab label={intl.formatMessage({id: "Title"})} {...a11yProps(0)} disableRipple/>
                            <Tab label={intl.formatMessage({id: "subTitle"})} {...a11yProps(1)} disableRipple/>
                        </Tabs>
                    </Box>
                    <TabPanel value={tabnum} index={0} className={clsx(classes.textBox, classes.textBoxTranslation)}>
                        <TextField
                            id="outlined-static-title"
                            placeholder={`${intl.formatMessage({id: "TitlePlaceholder"})}`}
                            variant="outlined"
                            inputProps={{maxLength: 30}}
                            value={noticeStore.title}
                            onChange={handleChangeTitle}
                        />
                        {userType === USER_TYPE.Admin && noticeStore.selectOption === NotificationType.All ? (
                            <TranslateButton disabled={disableTitle}
                                             onClick={translateAll}
                            />
                        ) : null}
                    </TabPanel>
                    <TabPanel value={tabnum} index={1} className={clsx(classes.textBox, classes.textBoxTranslation)}>
                        <TextField
                            id="outlined-static-subtitle"
                            placeholder={`${intl.formatMessage({id: "SubtitlePlaceholder"})}`}
                            variant="outlined"
                            inputProps={{maxLength: 30}}
                            value={noticeStore.subtitle}
                            onChange={handleChangeSubtitle}
                        />
                        {userType === USER_TYPE.Admin && noticeStore.selectOption === NotificationType.All ? (
                            <TranslateButton disabled={disableSubtitle}
                                             onClick={translateAll}
                            />
                        ) : null}
                    </TabPanel>
                </Box>
            </Box>
            {
                userType === USER_TYPE.Admin && noticeStore.selectOption === NotificationType.All ? (
                    <Box>
                        {/* 번역 박스 */}
                        <Box className={classes.boxBottomTranslation}>
                            {noticeStore.noticeBanners.length > 0 && noticeStore.noticeBanners.map((list, index) => {
                                if (list.languageCode !== localeStore.locale.toUpperCase()) {
                                    return translatingBox(list, index);
                                } else {
                                    return null;
                                }
                            })}
                        </Box>
                    </Box>
                ) : null
            }
        </Box>
    )
}

export default inject('authStore', 'noticeStore', 'groupStore', 'localeStore')(injectIntl(observer(NoticeBanner)));